<script lang="ts">
  let showMobileMenu = false
  const toggleMobileMenu = () => (showMobileMenu = !showMobileMenu)
  import Fa from 'svelte-fa'
  import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'
  import NavigationButtons from './Buttons.svelte'
</script>

<div class="mobile-topbar">
  {#if !showMobileMenu}
    <div id="mobile-topbar-items">
      <!-- TODO fix ignores -->
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="left" on:click={toggleMobileMenu}>
        <Fa icon={faBars} size="2x" color="#e5eeff" />
      </div>
    </div>
  {:else}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div id="menu-close-icon" on:click={toggleMobileMenu}>
      <Fa icon={faTimes} size="2x" />
    </div>
    <NavigationButtons mobile />
  {/if}
</div>
<div class="spacer" />

<style>
  .mobile-topbar {
    overflow: hidden;
    background-color: var(--tsf-black);
    color: var(--tsf-washed-grey);
    position: fixed;
    top: 0;
    width: 100%;
    min-width: 100vw;
    min-height: 5em;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
  }

  #mobile-topbar-items {
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
    justify-content: space-between;
    height: 5em;
  }

  #menu-close-icon {
    float: left;
    padding-left: 1em;
    padding-top: 1.5em;
  }

  .left {
    float: left;
    padding-left: 1em;
  }

  .spacer {
    height: 5em;
  }
</style>
